// layoutInspectorActions.js

function normalizeAction(action, { destructive = false } = {}) {
  if (!action || typeof action.onClick !== 'function') return null;

  const label = String(action?.label || action?.title || '').trim();
  if (!label) return null;

  return {
    destructive: destructive || action?.iconKey === 'delete' || action?.iconKey === 'close',
    iconKey: action?.iconKey || null,
    label,
    onClick: action.onClick,
    title: String(action?.title || action?.label || '').trim() || label,
  };
}

/**
 * buildLayoutInspectorSections
 *
 * @param {object|null} toolbarContext
 * @returns {array}
 */
export function buildLayoutInspectorSections(toolbarContext) {
  if (!toolbarContext) return [];

  const sections = [];
  const {
    activeSlotControls,
    containerLabel,
    containerToolbarActions = [],
  } = toolbarContext;

  const normalizedContainerActions = containerToolbarActions
    .map((action) => normalizeAction(action))
    .filter(Boolean);

  if (normalizedContainerActions.length) {
    sections.push({
      actions: normalizedContainerActions,
      key: 'container',
      label: String(containerLabel || 'Container').trim() || 'Container',
    });
  }

  if (activeSlotControls) {
    const structureActions = (activeSlotControls.slotToolbarStructureActions || [])
      .map((action) => normalizeAction(action))
      .filter(Boolean);

    const blockActions = (activeSlotControls.slotToolbarActions || [])
      .map((action) => normalizeAction(action))
      .filter(Boolean);

    const combinedBlockActions = [...structureActions, ...blockActions];
    if (combinedBlockActions.length) {
      sections.push({
        actions: combinedBlockActions,
        key: 'block',
        label: 'Block',
      });
    }

    const addContentActions = [
      ...(activeSlotControls.slotToolbarAddActions || []),
      ...(activeSlotControls.slotToolbarPageViewActions || []),
    ]
      .map((action) => normalizeAction(action))
      .filter(Boolean);

    if (addContentActions.length) {
      sections.push({
        actions: addContentActions,
        key: 'add-content',
        label: 'Add content',
      });
    }

    const menuActions = (activeSlotControls.slotMenuActions || [])
      .map((action) => normalizeAction(action))
      .filter(Boolean);

    if (menuActions.length) {
      sections.push({
        actions: menuActions,
        key: 'more',
        label: 'More actions',
      });
    }
  }

  return sections;
}
